// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LineOutlinedSvg from "@fishx/icons-svg/es/asn/LineOutlined";
import FishxIcon from '../components/FishxIcon';

var LineOutlined = function LineOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LineOutlinedSvg
  }));
};

LineOutlined.displayName = 'LineOutlined';
export default React.forwardRef(LineOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LineOutlined.js
// module id = 3043
// module chunks = 0